<template>
  <div class="paginacao">
    <div class="row">
      <div class="col-xs-12 flex">
        <button
          :class="['btn btn-primary', inputVal === 1 ? 'disabled' : '']"
          :disabled="inputVal === 1"
          @click="firstPage()"
          title="Primeira página"
        >
          <<<
        </button>
        <button
          :class="['btn btn-primary', inputVal === 1 ? 'disabled' : '']"
          :disabled="inputVal === 1"
          @click="prevPage()"
          title="Página anterior"
        >
          <
        </button>
        <v-select :options="options" v-model="inputVal" :clearable="false">
          <template #no-options="{ search, searching, loading }">
            Página não encontrada!
          </template>
        </v-select>
        <button
          :class="['btn btn-primary', inputVal === qtPaginas ? 'disabled' : '']"
          :disabled="inputVal === qtPaginas"
          @click="nextPage()"
          title="Próxima página"
        >
          >
        </button>
        <button
          :class="['btn btn-primary', inputVal === qtPaginas ? 'disabled' : '']"
          :disabled="inputVal === qtPaginas"
          @click="lastPage()"
          title="Última página"
        >
          >>>
        </button>
        <div class="self-end">
          {{
            `Exibindo de ${(inputVal - 1) * 100 + 1} a ${
              total < inputVal * 100 ? total : inputVal * 100
            } de um total de ${total}`
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    total: {
      type: Number,
      required: true
    },
    value: {
      type: Number
    }
  },
  data() {
    return {
      qtPaginas: Math.ceil(this.total / 100),
      test: this.total / 100
    }
  },
  methods: {
    firstPage() {
      this.inputVal = 1
    },
    lastPage() {
      this.inputVal = this.qtPaginas
    },
    prevPage() {
      this.inputVal -= 1
    },
    nextPage() {
      this.inputVal += 1
    }
  },
  computed: {
    options() {
      return Array.from(Array(this.qtPaginas).keys()).map(item => item + 1)
    },
    inputVal: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style scoped>
.v-select {
  display: inline-block;
  min-width: 100px;
}
.paginacao >>> .vs__selected,
.paginacao >>> .vs__dropdown-menu {
  font-size: 1.5rem;
}
.paginacao >>> {
  --vs-font-size: 1.5rem;
  --vs-line-height: 1.6;
}
.flex {
  display: flex;
  align-items: center;
  padding: 15px 15px;
  flex-wrap: wrap;
}

.self-end {
  margin-left: auto;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/DividaAtiva/Paginacao.vue